import { dew as _ClientDew } from "./api/resources/agents/client/Client";
import { dew as _Client2Dew } from "./api/resources/auth/client/Client";
import { dew as _Client3Dew } from "./api/resources/cells/client/Client";
import { dew as _Client4Dew } from "./api/resources/commits/client/Client";
import { dew as _Client5Dew } from "./api/resources/documents/client/Client";
import { dew as _Client6Dew } from "./api/resources/environments/client/Client";
import { dew as _Client7Dew } from "./api/resources/events/client/Client";
import { dew as _Client8Dew } from "./api/resources/files/client/Client";
import { dew as _Client9Dew } from "./api/resources/guests/client/Client";
import { dew as _Client10Dew } from "./api/resources/jobs/client/Client";
import { dew as _Client11Dew } from "./api/resources/mapping/client/Client";
import { dew as _Client12Dew } from "./api/resources/records/client/Client";
import { dew as _Client13Dew } from "./api/resources/secrets/client/Client";
import { dew as _Client14Dew } from "./api/resources/sheets/client/Client";
import { dew as _Client15Dew } from "./api/resources/snapshots/client/Client";
import { dew as _Client16Dew } from "./api/resources/spaces/client/Client";
import { dew as _Client17Dew } from "./api/resources/users/client/Client";
import { dew as _Client18Dew } from "./api/resources/versions/client/Client";
import { dew as _Client19Dew } from "./api/resources/workbooks/client/Client";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  /**
   * This file was auto-generated by Fern from our API Definition.
   */
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.FlatfileClient = void 0;
  const Client_1 = _ClientDew();
  const Client_2 = _Client2Dew();
  const Client_3 = _Client3Dew();
  const Client_4 = _Client4Dew();
  const Client_5 = _Client5Dew();
  const Client_6 = _Client6Dew();
  const Client_7 = _Client7Dew();
  const Client_8 = _Client8Dew();
  const Client_9 = _Client9Dew();
  const Client_10 = _Client10Dew();
  const Client_11 = _Client11Dew();
  const Client_12 = _Client12Dew();
  const Client_13 = _Client13Dew();
  const Client_14 = _Client14Dew();
  const Client_15 = _Client15Dew();
  const Client_16 = _Client16Dew();
  const Client_17 = _Client17Dew();
  const Client_18 = _Client18Dew();
  const Client_19 = _Client19Dew();
  class FlatfileClient {
    constructor(_options) {
      this._options = _options;
    }
    get agents() {
      var _a;
      return (_a = this._agents) !== null && _a !== void 0 ? _a : this._agents = new Client_1.Agents(this._options);
    }
    get auth() {
      var _a;
      return (_a = this._auth) !== null && _a !== void 0 ? _a : this._auth = new Client_2.Auth(this._options);
    }
    get cells() {
      var _a;
      return (_a = this._cells) !== null && _a !== void 0 ? _a : this._cells = new Client_3.Cells(this._options);
    }
    get commits() {
      var _a;
      return (_a = this._commits) !== null && _a !== void 0 ? _a : this._commits = new Client_4.Commits(this._options);
    }
    get documents() {
      var _a;
      return (_a = this._documents) !== null && _a !== void 0 ? _a : this._documents = new Client_5.Documents(this._options);
    }
    get environments() {
      var _a;
      return (_a = this._environments) !== null && _a !== void 0 ? _a : this._environments = new Client_6.Environments(this._options);
    }
    get events() {
      var _a;
      return (_a = this._events) !== null && _a !== void 0 ? _a : this._events = new Client_7.Events(this._options);
    }
    get files() {
      var _a;
      return (_a = this._files) !== null && _a !== void 0 ? _a : this._files = new Client_8.Files(this._options);
    }
    get guests() {
      var _a;
      return (_a = this._guests) !== null && _a !== void 0 ? _a : this._guests = new Client_9.Guests(this._options);
    }
    get jobs() {
      var _a;
      return (_a = this._jobs) !== null && _a !== void 0 ? _a : this._jobs = new Client_10.Jobs(this._options);
    }
    get mapping() {
      var _a;
      return (_a = this._mapping) !== null && _a !== void 0 ? _a : this._mapping = new Client_11.Mapping(this._options);
    }
    get records() {
      var _a;
      return (_a = this._records) !== null && _a !== void 0 ? _a : this._records = new Client_12.Records(this._options);
    }
    get secrets() {
      var _a;
      return (_a = this._secrets) !== null && _a !== void 0 ? _a : this._secrets = new Client_13.Secrets(this._options);
    }
    get sheets() {
      var _a;
      return (_a = this._sheets) !== null && _a !== void 0 ? _a : this._sheets = new Client_14.Sheets(this._options);
    }
    get snapshots() {
      var _a;
      return (_a = this._snapshots) !== null && _a !== void 0 ? _a : this._snapshots = new Client_15.Snapshots(this._options);
    }
    get spaces() {
      var _a;
      return (_a = this._spaces) !== null && _a !== void 0 ? _a : this._spaces = new Client_16.Spaces(this._options);
    }
    get users() {
      var _a;
      return (_a = this._users) !== null && _a !== void 0 ? _a : this._users = new Client_17.Users(this._options);
    }
    get versions() {
      var _a;
      return (_a = this._versions) !== null && _a !== void 0 ? _a : this._versions = new Client_18.Versions(this._options);
    }
    get workbooks() {
      var _a;
      return (_a = this._workbooks) !== null && _a !== void 0 ? _a : this._workbooks = new Client_19.Workbooks(this._options);
    }
  }
  exports.FlatfileClient = FlatfileClient;
  return exports;
}